// start:ng42.barrel
import './components';
import './controllers';
import './corporate-contacts.service';
// end:ng42.barrel

